import { Box, Typography } from '@mui/material';
import { ServiceCategory } from 'orderme-api-integration-client';
import { apiKey, imagesUri } from '../../helpers/clientConfigs';

interface CategoryItemProps {
  category: ServiceCategory;
  imageSize?: number;
}

export function CategoryItem(props: CategoryItemProps) {
  const { category, imageSize = 30 } = props;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <img
        width={imageSize}
        height={imageSize}
        src={`${imagesUri}/${category.logoId}?orderme-api-key=${apiKey}&width=${imageSize * 2}`}
        alt={category.name}
      />
      <Typography
        sx={{
          color: 'white',
          pt: '5px',
          fontSize: '12px',
          textAlign: 'center',
          width: { xs: '80px', sm: '100px', md: 'auto' },
        }}
      >
        {category.name}
      </Typography>
    </Box>
  );
}
